import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import SEO from '../components/SEO';
import { NEWS_ARTICLES } from '../data/newsArticles';
import '../styles/aiNewsHub.css';

// Article component registry - add new entries here as articles grow
import ChatGPTLaunch    from '../components/news/ChatGPTLaunch';
import DeepSeekMoment   from '../components/news/DeepSeekMoment';
import DeepSeekV4       from '../components/news/DeepSeekV4';
import MiniMaxAI        from '../components/news/MiniMaxAI';
import Grok4Launch      from '../components/news/Grok4Launch';
import NvidiaDGXSpark   from '../components/news/NvidiaDGXSpark';
import RDMACluster      from '../components/news/RDMACluster';
import AnthropicMythos  from '../components/news/AnthropicMythos';
import Gemma4Launch      from '../components/news/Gemma4Launch';
import SingaporeAIGov   from '../components/news/SingaporeAIGov';
import QwenOpenSource   from '../components/news/QwenOpenSource';
import OpenClaude       from '../components/news/OpenClaude';
import GoogleTurboQuant from '../components/news/GoogleTurboQuant';
import ILMUMalaysia     from '../components/news/ILMUMalaysia';
import MistralAI        from '../components/news/MistralAI';
import Gemini3Launch    from '../components/news/Gemini3Launch';
import NanoBanana       from '../components/news/NanoBanana';
import VeraRubin              from '../components/news/VeraRubin';
import AMDInstinct            from '../components/news/AMDInstinct';
import OpenClaw               from '../components/news/OpenClaw';
import LobsterAI              from '../components/news/LobsterAI';
import Seedance2              from '../components/news/Seedance2';
import NvidiaBlackwell        from '../components/news/NvidiaBlackwell';
import HumanoidRobotics       from '../components/news/HumanoidRobotics';
import DigitalTwin            from '../components/news/DigitalTwin';
import PredictiveAnalytics    from '../components/news/PredictiveAnalytics';
import Llama4OpenSource       from '../components/news/Llama4OpenSource';
import KimiModels             from '../components/news/KimiModels';
import ParallelAgents         from '../components/news/ParallelAgents';
import ASEANAIGovernance      from '../components/news/ASEANAIGovernance';
import SingaporeAgenticAI     from '../components/news/SingaporeAgenticAI';
import VietnamAILaw           from '../components/news/VietnamAILaw';
import MalaysiaIndonesiaAIGov from '../components/news/MalaysiaIndonesiaAIGov';
import ClaudeMilitary         from '../components/news/ClaudeMilitary';
import HermesAgent            from '../components/news/HermesAgent';
import GPT55Launch            from '../components/news/GPT55Launch';
import HappyHorseAlibaba      from '../components/news/HappyHorseAlibaba';
import Hanyuan02Quantum       from '../components/news/Hanyuan02Quantum';

const ARTICLE_COMPONENTS = {
  'chatgpt-launch-2022':                  ChatGPTLaunch,
  'deepseek-moment-2025':                 DeepSeekMoment,
  'deepseek-v4-preview-2026':             DeepSeekV4,
  'minimax-m27-2026':                     MiniMaxAI,
  'grok-4-xai-2025':                      Grok4Launch,
  'nvidia-dgx-spark-2025':                NvidiaDGXSpark,
  'rdma-cluster-ai-networking':           RDMACluster,
  'anthropic-mythos-preview-2026':        AnthropicMythos,
  'gemma-4-google-edge-ai-2026':          Gemma4Launch,
  'singapore-ai-governance-scam':         SingaporeAIGov,
  'qwen-open-source-alibaba-2025':        QwenOpenSource,
  'anthropic-open-claude-oss':            OpenClaude,
  'google-turboquant-kv-cache-2026':      GoogleTurboQuant,
  'ilmu-malaysia-ai-2025':                ILMUMalaysia,
  'mistral-ai-open-source':               MistralAI,
  'gemini-3-launch-2025':                 Gemini3Launch,
  'nano-banana-google-image-2026':        NanoBanana,
  'nvidia-vera-rubin-2026':               VeraRubin,
  'amd-instinct-mi350-supercomputer':     AMDInstinct,
  'openclaw-clawd-moltbot-2026':          OpenClaw,
  'lobsterai-netease-youdao-2026':        LobsterAI,
  'seedance-2-bytedance-video-2026':         Seedance2,
  'nvidia-blackwell-architecture-2025':     NvidiaBlackwell,
  'humanoid-robotics-unitree-nvidia-groot-2026': HumanoidRobotics,
  'digital-twin-nvidia-omniverse-2026':     DigitalTwin,
  'ai-predictive-analytics-enterprise-2026': PredictiveAnalytics,
  'llama-4-open-source-wave-2025':          Llama4OpenSource,
  'kimi-k2-5-moonshot-ai-2026':             KimiModels,
  'parallel-agents-architecture-2026':    ParallelAgents,
  'asean-ai-governance-framework-2025':   ASEANAIGovernance,
  'singapore-agentic-ai-governance-2026': SingaporeAgenticAI,
  'vietnam-ai-law-sea-first-2026':        VietnamAILaw,
  'malaysia-indonesia-sea-ai-governance': MalaysiaIndonesiaAIGov,
  'claude-military-autonomous-weapons-2026': ClaudeMilitary,
  'openai-gpt-5-5-launch-2026':            GPT55Launch,
  'hermes-agent-nous-research-2026':       HermesAgent,
  'happy-horse-alibaba-video-2026':        HappyHorseAlibaba,
  'hanyuan-02-dual-core-quantum-2026':     Hanyuan02Quantum,
};

const AINewsArticle = () => {
  const { slug } = useParams();
  const { language } = useLanguage();

  const meta    = NEWS_ARTICLES.find(a => a.slug === slug);
  const Content = ARTICLE_COMPONENTS[slug];

  if (!meta || !Content) {
    return (
      <div className="news-article-page">
        <div className="container">
          <div className="news-not-found">
            <h2>Article not found</h2>
            <p>This article may have moved or been removed.</p>
            <Link to={`/${language}/ai-news`} className="news-article-back">
              ← Back to AI News Hub
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="news-article-page">
      <SEO
        title={meta.title}
        description={meta.excerpt}
        keywords={meta.tags.join(', ')}
        canonicalPath={`/${language}/ai-news/${slug}`}
      />

      <div className="container">
        <Link to={`/${language}/ai-news`} className="news-article-back">
          ← AI News Hub
        </Link>

        <header className="news-article-header">
          <span className={`news-category-badge ${meta.category}`}>{meta.category}</span>
          <h1>{meta.title}</h1>
          <div className="news-article-meta">
            <span>{meta.displayDate}</span>
            <span>·</span>
            {meta.tags.map(tag => (
              <span key={tag} className="news-tag">#{tag}</span>
            ))}
          </div>
        </header>

        <Content />

        {/* Sources */}
        {meta.sources?.length > 0 && (
          <div className="news-article-sources">
            <h4>Sources</h4>
            <ul className="news-sources-list">
              {meta.sources.map(s => (
                <li key={s.url}>
                  <a href={s.url} target="_blank" rel="noopener noreferrer">
                    {s.label} ↗
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default AINewsArticle;
